import Vue from 'vue'
import Modal from '@/components/modal/Modal.vue'
import InputText from '@/components/inputText/InputText.vue'
import Dropdown from '@/components/dropdown/Dropdown.vue'
import ModalPage from '@/components/modalPage/ModalPage.vue'
import storageKeys from '@/consts/storageKeys'


const contractionString = (inputString) => {

    if (!inputString) {
        return ''
    }

    if (inputString.length <= 14) {
        return inputString
    }

    return inputString.slice(0, 14).trim() + '...'
}

const updateSiteNameInSiteHistory = (id, newName) => {
    const siteHistoryJSON = localStorage.getItem(storageKeys.SITE_HISTORY);

    if (!siteHistoryJSON) {
        return []
    }

    const siteHistory = JSON.parse(siteHistoryJSON);

    const siteInHistory = siteHistory.find(site => site.id === id);
    siteInHistory.name = newName;
    localStorage.setItem(storageKeys.SITE_HISTORY, JSON.stringify(siteHistory))
    return siteHistory
}

export default {
    name: 'user-info',
    inject: ['auth', 'localization'],
    data() {
        return {
            form: {
                site: {
                    name: 'site',
                    validator: { required: true, uniqueObject: true },
                    placeholder: 'global.site',
                    value: null,
                }
            },
            editing: false,
            siteHistory: [],
            links: [
                { name: 'global.aboutSecuros', alias: 'about' },
                // { name: 'global.help', alias: 'help' },
            ],
            lang: {
                active: this.$store.state.i18n.locale,
                modal: false,
                list: [
                    { name: 'en', title: 'Eng' },
                    { name: 'ru', title: 'Рус' },
                ]
            }
        }
    },
    computed: {
        title() {
            if (this.$store.state.user === false || !this.$store.state.user.site.name) {
                return this.loginText('', contractionString(this.$store.state.user.login))
            }

            return this.loginText(contractionString(this.$store.state.user.site.name), this.$store.state.user.login)
        },
        siteActionName() {
            if (this.$store.state.user === false || !this.$store.state.user.site.name) {
                return this.$t('profileMenu.addSiteName')
            }

            return this.$t('profileMenu.editSiteName')
        },
        modalTitle() {
            if (this.$store.state.user === false || !this.$store.state.user.site.name) {
                return this.$t("editSite.createSiteTitle")
            }
            return this.$t('editSite.editSiteTitle')
        }
    },
    created() {
        const siteHistoryJSON = localStorage.getItem(storageKeys.SITE_HISTORY)
        this.siteHistory = siteHistoryJSON ? JSON.parse(siteHistoryJSON) : []

        this.$validator.extend('uniqueObject', {
            getMessage: field => 'customValidationError.uniqueObject',
            validate: (newSiteName) => {

                return !this.siteHistory.some(site => {
                    return newSiteName == site.name
                })
            }
        })
    },
    methods: {
        logout() {
            this.auth.logout().then(() => {
                const websoketConnection = this.$store.state.wsWebConnect
                if (websoketConnection) {
                    websoketConnection.close()
                }
                this.$router.push({ name: 'auth' })
            })
        },
        edit() {
            this.form.site.value = this.$store.state.user.site.name
            this.editing = true

            Vue.nextTick(() => {
                let input = this.$refs['form-object']

                if (input)
                    input.$emit('focus')
            })
        },
        save() {
            const usersJson = localStorage.getItem(storageKeys.USERS)

            if (!usersJson) {
                return
            }

            const users = JSON.parse(usersJson)
            const user = users.find(userInUsers => userInUsers.login == this.$store.state.user.login)

            if (!user) {
                return
            }

            user.site.name = this.form.site.value;
            this.$store.commit('setUser', user)
            localStorage.setItem(storageKeys.USERS, JSON.stringify(users))

            this.siteHistory = updateSiteNameInSiteHistory(user.site.id, this.form.site.value)

            this.editing = false

        },
        changeLang() {
            this.localization.set(this.lang.active)
            this.lang.modal = false
        },
        loginText(siteName = '', login = this.$store.state.user.login) {
            const siteNameFromStore = (this.$store.state.user && this.$store.state.user.site && this.$store.state.user.site.name) ? this.$store.state.user.site.name : ''
            const siteNameCopy = siteName ? siteName : siteNameFromStore

            if (!siteNameCopy) {
                return login
            }

            return `${siteNameCopy} > ${login}`
        }
    },
    components: {
        Modal,
        InputText,
        Dropdown,
        ModalPage
    }
}



// WEBPACK FOOTER //
// ./src/modules/userInfo/userInfo.js